import { Injectable } from '@angular/core';
import { Environment } from '@r1-compass-library/environments/environment';
import { TemplateCriteriaFolder } from '@r1-compass-library/models';
import { FolderRestService } from './rest/folder-rest.service';
import { BasicFolderSearch } from '@r1-compass-library/models/search/basic-folder-search.model';

@Injectable({ providedIn: 'root' })
export class TemplateCriteriaFolderService extends FolderRestService<TemplateCriteriaFolder, BasicFolderSearch> {
    protected BASE_URL: string = Environment.baseUrl + '/frontend/template-criteria-folders';
    protected override TARGET_OBJECT = 'template-criteria-folder';

    processNamePrefix = 'TemplateCriteriaFolderService';
}
